<template>
  <div class="important-page-c display--flex fd--column">
    <!-- 搜索 -->
    <div class="search-form btn-2b5a95">
      <div
        class="l-w"
        :style="{
          height: $store.state.global.isSearchExtend
            ? ''
            : $store.state.global.searchFormHeight + 10 + 'px',
        }"
      >
        <el-form
          label-position="right"
          :class="$store.state.global.isSearchExtend ? '' : 'overflow--hidden'"
					:model="searchForm"
					@submit.native.prevent
        >
					<el-form-item label="流水号:">
						<el-input 
							v-model.trim="searchForm.id" 
							@keyup.enter.native="seach"
							clearable />
					</el-form-item>
          <el-form-item label="开户名称:">
            <el-input 
							v-model.trim="searchForm.accountname" 
							@keyup.enter.native="seach"
							clearable />
          </el-form-item>
          <el-form-item label="审核状态:">
            <el-select 
							v-model="searchForm.approvestate" 
							@keyup.enter.native="seach"
							@visible-change="visiableType"
							ref="selectref"
							clearable>
              <el-option value="-2" label="未提请审批" />
              <el-option value="-1" label="审核中" />
              <el-option value="0" label="审核不通过" />
              <el-option value="1" label="通过" />
            </el-select>
          </el-form-item>
          <el-form-item label="所属教学点:">
            <el-input 
							v-model.trim="searchForm.schoolorgname" 
							@keyup.enter.native="seach"
							clearable />
          </el-form-item>
					<el-form-item label="银行卡号:">
					  <el-input 
							v-model.trim="searchForm.cardno" 
							@keyup.enter.native="seach"
							clearable />
					</el-form-item>
        </el-form>
      </div>
      <div class="r-w">
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="seach"
          :loading="!$store.state.global.isEndRequest"
          class="btn-2b5a95"
          >搜索</el-button
        >
				<el-button type="primary" @click="resetQuery">重置</el-button>
        <el-button
          type="primary"
          :icon="
            $store.state.global.isSearchExtend
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          v-if="$store.state.global.showSearchExtend"
          class="btn-2b5a95"
          @click="onExtendClick('isSearchExtend')"
          >{{ $store.state.global.searchExtendText }}</el-button
        >
      </div>
    </div>

    <!-- 按钮操作 -->
    <div
      class="Btn-w eaf4ff-btn"
      v-if="tableRes.buttonlist && tableRes.buttonlist.length"
      :style="{
        height: $store.state.global.isBtnExtend
          ? ''
          : $store.state.global.BtnHeight + 10 + 'px',
      }"
    >
      <div
        class="btn-l"
        v-if="tableRes.buttonlist"
        :class="$store.state.global.isBtnExtend ? '' : 'overflow--hidden'"
      >
        <el-button
          v-for="(item, index) in tableRes.buttonlist"
          :key="index"
          type="primary"
          @click="onClickBtn(item.buttonname)"
          >{{ item.name }}
        </el-button>
      </div>
      <div class="Btn-extend">
        <el-button
          type="primary"
          v-if="$store.state.global.showBtnExtend"
          class="btn-2b5a95"
          :icon="
            $store.state.global.isBtnExtend
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          @click="onExtendClick('isBtnExtend')"
          >{{ $store.state.global.BtnExtendText }}</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    <el-table
      :data="tableRes.list"
      border
			stripe
			:header-cell-style="{ background: '#044d8c', color: '#fff'}"
      ref="multipleTable"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
			<el-table-column label="流水号" prop="id" align="center" width="100"/>
      <el-table-column label="开户名称" prop="accountname" align="center" width="330">
        <template slot-scope="scope">
          <el-button @click="btnShowDetail(scope.row)" type="text">{{
            scope.row.accountname
          }}</el-button>
        </template>
      </el-table-column>

      <el-table-column 
				label="银行名称" 
				prop="bankname" 
				align="center"
				:show-overflow-tooltip="true"
				/>
      <el-table-column 
				label="银行卡号" 
				align="center"
				prop="cardno"
				:show-overflow-tooltip="true"
				/>
      <el-table-column label="当前余额" prop="curmoney" align="center" />

      <el-table-column label="审核状态" prop="approvestate" align="center">
        <template slot-scope="scope">
          {{ approvestateObj[scope.row.approvestate] }}
        </template>
      </el-table-column>

      <el-table-column label="所属教学点" prop="schoolorgname" align="center" width="160"/>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="pageinfo.pageindex"
      :page-size="pageinfo.pagesize"
      :page-sizes="[10, 20, 30, 40, 50]"
      layout="total, prev, pager, next, jumper"
      :total="tableRes.totalcount"
    ></el-pagination>

    <!--添加，修改-->
    <el-dialog
      class="btn-2b5a95"
      width="35%"
      :title="dialogTitle"
			:close-on-click-modal='false'
      :visible.sync="showAddModal"
      v-if="showAddModal"
			v-dialogDrag
      append-to-body
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        label-width="20%"
        class="demo-dynamic form-item-w-100"
        status-icon
        :rules="rules"
      >
        <el-form-item prop="companyorgname" label="所属分公司">
          <el-select
            v-model="dynamicValidateForm.companyorgname"
            placeholder="请选择"
            :disabled="!$store.state.login.isMaxAuth"
            clearable
            @change="onChangeCompany($event, 'dynamicValidateForm')"
          >
            <el-option
              v-for="item in $store.state.selectData.companyList"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="schoolorgname" label="所属教学点">
          <el-select
            v-model="dynamicValidateForm.schoolorgname"
            placeholder="请选择"
            clearable
            @change="onChangeSchool($event, 'dynamicValidateForm')"
          >
            <el-option
              v-for="item in $store.state.selectData.schoolList"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="银行名称:"
          prop="bankname"
          class="hoveFrom urlLink"
        >
          <el-select
            v-model="dynamicValidateForm.bankname"
						placeholder="请选择"
						clearable
          >
            <el-option
              v-for="item in bankList"
              :key="item.key"
              :value="item.val"
              :label="item.val"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="开户名称:"
          prop="accountname"
          class="hoveFrom selectBtn"
        >
          <el-input v-model.trim="dynamicValidateForm.accountname" clearable/>
        </el-form-item>
        <el-form-item
          label="银行卡号:"
          prop="cardno"
          class="hoveFrom selectBtn"
        >
          <el-input 
						v-model.trim="dynamicValidateForm.cardno" 
						clearable 
						type="text"
						placholder="请输入银行卡号"
						/>
        </el-form-item>
        <el-form-item
          label="存折账号:"
          prop="bookno"
          class="hoveFrom selectBtn"
        >
          <el-input 
						v-model.trim="dynamicValidateForm.bookno" 
						clearable
						type="text"
						placholder="请输入存折账号"
					/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitAddOrEditForm('dynamicValidateForm')"
          :loading="!$store.state.global.isEndRequest"
          >提交
        </el-button>
      </span>
    </el-dialog>

    <!-- 银行卡号更改 -->
    <el-dialog
      class="btn-2b5a95"
      title="银行卡号更改"
			:close-on-click-modal='false'
      :visible.sync="showBankChangeModal"
      v-if="showBankChangeModal"
      append-to-body
			v-dialogDrag
      width="35%"
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        class="demo-dynamic form-item-w-100"
        status-icon
        label-width="20%"
        :rules="rules"
      >
        <el-form-item label="银行名称">
          <el-input v-model.trim="dynamicValidateForm.bankname" disabled />
        </el-form-item>
        <el-form-item label="存折账号">
          <el-input v-model.trim="dynamicValidateForm.bookno" disabled />
        </el-form-item>
        <el-form-item label="旧卡号">
          <el-input v-model.trim="dynamicValidateForm.cardnoold" disabled />
        </el-form-item>
        <el-form-item prop="cardnonew" label="新卡号">
          <el-input v-model.trim="dynamicValidateForm.cardnonew" />
        </el-form-item>
        <el-form-item prop="changeusername" label="变更人:">
          <el-input v-model.trim="dynamicValidateForm.changeusername" disabled />
          <el-button
            type="primary"
            class="select-btn"
            @click="onSelectData(vuser_dialogresult, 'showUserModal')"
            >选择</el-button
          >
        </el-form-item>
        <el-form-item prop="changtime" label="变更时间">
          <el-date-picker
            v-model="dynamicValidateForm.changtime"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd 00:00:00"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitBankChangeForm('dynamicValidateForm')"
          >提交
        </el-button>
      </span>
    </el-dialog>

    <!-- 选择变更人 -->
    <el-dialog
      class="btn-2b5a95"
			width="60%"
			:close-on-click-modal='false'
      @close="onCloseSelect"
      title="选择变更人"
      :visible.sync="showUserModal"
      v-if="showUserModal"
			v-dialogDrag
      append-to-body
    >
      <el-button type="primary" class="confirm" @click="comfirmUser"
        >确 定</el-button
      >

      <div class="index_2 btn-2b5a95">
        <div
          class="l-w"
          :style="{
            height: $store.state.global.isSearchExtend_2
              ? ''
              : $store.state.global.searchFormHeight_2 + 10 + 'px',
          }"
        >
          <el-form
            label-position="right"
            :class="
              $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
            "
            :model="selectSearchForm"
						@submit.native.prevent
          >
            <el-form-item label="姓名:" prop="realname">
              <el-input 
								v-model.trim="selectSearchForm.realname" 
								@keyup.enter.native="onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign({}, selectSearchForm)
              )"
								clearable />
            </el-form-item>
          </el-form>
        </div>
        <div class="r-w">
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="!$store.state.global.isEndRequest"
            class="btn-2b5a95"
            @click="
              onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign({}, selectSearchForm)
              )
            "
            >搜索</el-button
          >
					<el-button type="primary" @click="handleQuery">重置</el-button>
          <el-button
            type="primary"
            :icon="
              $store.state.global.isSearchExtend_2
                ? 'el-icon-arrow-up'
                : 'el-icon-arrow-down'
            "
            v-if="$store.state.global.searchExtend_2"
            class="btn-2b5a95"
            @click="onExtendClick('isSearchExtend_2')"
            >{{ $store.state.global.searchExtendText_2 }}</el-button
          >
        </div>
      </div>

      <el-table
        :data="selectTable.list"
        style="width: 100%"
				border
				stripe
				:key="key"
				:header-cell-style="{background: '#004d8c', color:'#FFFFFF'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="流水号" prop="id" align="center" />
        <el-table-column label="真实姓名" prop="realname" align="center" />
        <el-table-column label="员工工号" prop="worknumber" align="center" />
        <el-table-column
          label="所属分公司名称"
          prop="companyorgname"
          align="center"
        />
        <el-table-column
          label="所属教学点名称"
          prop="schoolorgname"
          align="center"
        />
        <el-table-column
          label="所属部门名称"
          prop="departorgname"
          align="center"
        />
        <el-table-column label="岗位名称" prop="positionname" align="center" />
      </el-table>

      <!-- 分页 -->
      <el-pagination
        background
        @current-change="
          (val, data) => handleSelectChange(val, selectSearchForm)
        "
        :current-page="selectPageInfo.pageindex"
        :page-size="selectPageInfo.pagesize"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, prev, pager, next, jumper"
        :total="tableRes.totalcount"
      ></el-pagination>

     

    </el-dialog>

    <el-dialog
      class="btn-2b5a95"
			:close-on-click-modal='false'
      :visible.sync="showRecordModal"
      v-if="showRecordModal"
			title="查看变更记录"
      append-to-body
			v-dialogDrag
			width="80%"
    >
      <!-- 表格 -->
      <el-table
        :data="recordTable.list"
        style="width: 100%"
        @selection-change="handleSelectionChange"
				border
				:key="key"
				stripe
				:header-cell-style="{background: '#004d8c', color:'#FFFFFF'}"
      >
        <el-table-column label="流水号" prop="id" align="center" width="100"/>
        <el-table-column label="银行名称" prop="bankname" align="center" :show-overflow-tooltip="true"/>
        <el-table-column label="原银行卡卡号" prop="cardnoold" align="center" :show-overflow-tooltip="true" width="200"/>
        <el-table-column
          label="变更后银行卡卡号"
          prop="cardnonew"
          align="center"
					width="200"
        />
        <el-table-column
          label="变更人名称"
          prop="changeusername"
          align="center"
					width="100"
        />
        <el-table-column label="变更时间" align="center" width="200">
          <template slot-scope="scope">
            {{ scope.row.changtime | formatDate("YYYY-MM-DD HH:mm:ss") }}
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        background
        @current-change="recordHandleCurrentChange"
        :current-page="pageinfo.recordPageindex"
        :page-size="pageinfo.pagesize"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, prev, pager, next, jumper"
        :total="recordTable.totalcount"
      ></el-pagination>
    </el-dialog>

    <!-- 查看审批 -->
    <el-dialog
      class="btn-2b5a95"
      title="审批记录："
			width="60%"
			v-dialogDrag
			:close-on-click-modal='false'
      :visible.sync="showModal"
      v-if="showModal"
      append-to-body
    >
      <el-table 
				:data="showTable.list" 
				style="width: 100%"
				border
				:key="key"
				stripe
				:header-cell-style="{background: '#004d8c', color:'#FFFFFF'}"
				>
        <el-table-column label="流水号" prop="id" align="center" />
        <el-table-column label="员工名称" prop="objectname" align="center" />
        <el-table-column label="审核是否通过标志" align="center">
          <template slot-scope="scope">
            {{ scope.row.passflag == 1 ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column label="审批意见" prop="approvedesc" align="center" />
        <el-table-column label="审批时间" prop="approvetime" align="center">
          <template slot-scope="scope">
            {{ scope.row.approvetime | formatDate("YYYY-MM-DD") }}
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>

    <!-- 会计审批表单 -->
    <el-dialog
      class="btn-2b5a95"
      title="会计审批："
			:close-on-click-modal='false'
      :visible.sync="showApprovalModal"
      v-if="showApprovalModal"
      append-to-body
			v-dialogDrag
      width="35%"
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        class="demo-dynamic form-item-w-100"
        status-icon
        
      >
        <el-form-item
          label="审核是否通过："
          prop="passflag"
          :rules="[
            {
              required: true,
              message: '必填字段',
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            v-model="dynamicValidateForm.passflag"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in [
                { value: 1, label: '通过' },
                { value: 0, label: '不通过' },
              ]"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="审批意见："
          prop="approvedesc"
          :rules="[
            {
              required: true,
              message: '必填字段',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            type="textarea"
            v-model.trim="dynamicValidateForm.approvedesc"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="onApprovalClick('dynamicValidateForm')"
          >提交
        </el-button>
      </span>
    </el-dialog>

    <Export
      :exportTitle="'银行初始配置'"
      :transferDialog="transferDialog"
      :exportUrl="exportUrl"
      :exportexcelUrl="exportexcelUrl"
      :searchForm="searchForm"
      @onCloseExport="onCloseExport"
    ></Export>

    <!-- 查看详情 -->
    <el-dialog
      class="btn-2b5a95"
      width="60%"
      :visible.sync="showDetailModal"
			:close-on-click-modal='false'
			v-dialogDrag
      v-if="showDetailModal"
      append-to-body
			title="详情"
    >
      <table border="1" cellpadding="10" cellspacing="0" class="base_table">
        <tr>
          <td v-if="dynamicValidateForm.bankorcash == 0">现金/银行：银行</td>
          <td v-if="dynamicValidateForm.bankorcash == 1">现金/银行：现金</td>
          <td>开户名称：{{ dynamicValidateForm.accountname }}</td>
          <td v-if=" dynamicValidateForm.isposflag == 0">是否总部POS机：否</td>
					<td v-if=" dynamicValidateForm.isposflag == 1">是否总部POS机：是</td>
        </tr>
        <tr>
          <td>初始金额：{{ dynamicValidateForm.initmoney }}</td>
          <td>当前金额：{{ dynamicValidateForm.curmoney }}</td>
          <td>银行卡号：{{ dynamicValidateForm.cardno }}</td>
        </tr>
        <tr>
          <td>存折账号：{{ dynamicValidateForm.bookno }}</td>
          <td v-if=" dynamicValidateForm.initedflag == 0">是否已初始化：否</td>
					<td v-if=" dynamicValidateForm.initedflag == 1">是否已初始化：是</td>
          <td v-if=" dynamicValidateForm.kuaijiapproveflag == -2">会计审核标志：未提请审批</td>
					<td v-if=" dynamicValidateForm.kuaijiapproveflag == -1">会计审核标志：审核中</td>
					<td v-if=" dynamicValidateForm.kuaijiapproveflag == 0">会计审核标志：未通过</td>
					<td v-if=" dynamicValidateForm.kuaijiapproveflag == 1">会计审核标志：通过</td>
        </tr>
        <tr>
          <td>会计审核时间：{{ dynamicValidateForm.kuaijiapprovetime | formatDate("YYYY-MM-DD HH:mm:ss")  }}</td>
          <td v-if="dynamicValidateForm.ceoapproveflag == -2">总裁审核标志：未提请审批 </td>
					<td v-if="dynamicValidateForm.ceoapproveflag == -1">总裁审核标志：审核中  </td>
					<td v-if="dynamicValidateForm.ceoapproveflag == 0">总裁审核标志：未通过 </td>
					<td v-if="dynamicValidateForm.ceoapproveflag == 1">总裁审核标志：通过 </td>
          <td>总裁审核时间：{{ dynamicValidateForm.ceoapprovetime | formatDate("YYYY-MM-DD HH:mm:ss") }}</td>
        </tr>
        <tr>
          <td>会计审核意见：{{ dynamicValidateForm.kuaijiapprovedesc }}</td>
          <td>总裁审核意见：{{ dynamicValidateForm.ceoapprovedesc }}</td>
          <td v-if="dynamicValidateForm.approvestate == -2">审核状态：未提请审批</td>
					<td v-if="dynamicValidateForm.approvestate == -1">审核状态：审核中</td>
					<td v-if="dynamicValidateForm.approvestate == 0">审核状态：未通过</td>
					<td v-if="dynamicValidateForm.approvestate == 1">审核状态：通过</td>
        </tr>
        <tr>
          <td>所属教学点名称：{{ dynamicValidateForm.schoolorgname }}</td>
          <td>所属教学点序号：{{ dynamicValidateForm.schoolorgcode }}</td>
          <td>所属分公司名称：{{ dynamicValidateForm.companyorgname }}</td>
        </tr>
        <tr>
          <td>所属分公司序号：{{ dynamicValidateForm.companyorgcode }}</td>
          <td>审核会计名称：{{ dynamicValidateForm.kuaijiname }}</td>
          <td>审核CEO姓名：{{ dynamicValidateForm.ceoname }}</td>
        </tr>
        <tr>
          <td>银行名称：{{ dynamicValidateForm.bankname }}</td>
          <td v-if="dynamicValidateForm.status == 0">账户是否可用状态：否</td>
					<td v-if="dynamicValidateForm.status == 1">账户是否可用状态：是</td>
					<td>流水号： {{dynamicValidateForm.id}}</td>
        </tr>
      </table>
    </el-dialog>
  </div>
</template>

<script>
import { part } from "@/utils/mixins";
import { mapActions } from "vuex";

import Export from "@/components/Export/index.vue";
import {
  account_listbank,
  account_inputbank,
  account_savebank,
  bankaccountchange_input,
  bankaccountchange_save,
  bankaccountchange_list,
  account_requestapprove,
  account_approvecheck,
  account_approvesave,
  account_export,
  account_exportexcel,
  account_exportsave,
  approve_list,
} from "@/request/api/allChildrenProject";

import {
  _org_combox,
  _allSchool,
  _bank_bankbox,
  _vuser_dialogresult,
	 dic_combox,
} from "@/request/api/public";

import { myRequest } from "@/request/index";
import {
  messageTip,
  formatDare,
  selectCheck,
  confirmCallBack,
  createObjParams,
} from "@/utils/util";
export default {
  mixins: [part],
  name: "account2",
  components: { Export },
  props: {
    exportUrl: {
      default: () => account_export,
    },
    exportexcelUrl: {
      default: () => account_exportexcel,
    },
    exportsaveUrl: {
      default: () => account_exportsave,
    },
    vuser_dialogresult: {
      default: () => _vuser_dialogresult,
    },
  },
  data() {
    //数值表单规则
    var checkfield = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("必填字段"));
      } else {
        if (isNaN(Number(value))) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      }
    };
    return {
      approvestateObj: {
        1: "通过",
        "-1": "审核中",
        "-2": "未提请审核",
        0: "审核不通过",
      },
      bankList: [], // 银行数组
      searchForm: { id: null },
      transferDialog: false, //导出框
      itemId: null, //首表格项id
      tableRes: {}, //列表接口
      recordTable: {}, // 查看变更记录接口
      pageinfo: {
        pageindex: 1,
        pagesize: 10,
      }, //页数查询
      showRecordModal: false, // 变更记录
      dynamicValidateForm: {}, //表单
      showAddModal: false, //显示表单框
      multipleSelection: [], //选中的表格项
      dynamicValidateForm: {}, // 银行卡号更改
      showBankChangeModal: false, // 银行卡号更改
      rules: {
        cardno: [{ trigger: "blur", message: "必填字段", required: true }],
        bookno: [{ trigger: "blur", message: "必填字段", required: true }],
        bankname: [{ trigger: "blur", message: "必填字段", required: true }],
        bankname: [{ trigger: "blur", message: "必填字段", required: true }],
        accountname: [{ trigger: "blur", message: "必填字段", required: true }],
        schoolorgname: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        companyorgname: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        changeusername: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        cardnonew: [{ trigger: "blur", message: "必填字段", required: true }],
        changtime: [{ trigger: "blur", message: "必填字段", required: true }],
      }, //表单规则

      showApprovalModal: false, //审批框

      showTable: {}, //查看审批 data
      showModal: false, //查看审批框

      // 选择变更人
      showUserModal: false,
      selectTable: {},
      selectTableUrl: "",
			key: '',
      selectSearchForm: {},
      selectPageInfo: {
        pageindex: 1,
        pagesize: 10,
      },
      showDetailModal: false,
    };
  },
  created() {
    this.searchForm.id = this.$route.params.id;
    this.getDataList();
    this.org_combox();
    this.org_comboxchild(this.dynamicValidateForm.companyorgid);
		this.dic_combox({ typecode: "bank", list: "bankList", that: this });
		window.addEventListener("keyup", this.enterSelect);
  },
	watch: {
		['dynamicValidateForm.cardno'](val) {
			if (val != undefined) {
				this.$nextTick(() => {
					this.dynamicValidateForm.cardno = val.replace(/\D/g,'').replace(/....(?!$)/g,'$& ');
				})
			}
		},
		['dynamicValidateForm.bookno'](value) {
			if (value != undefined) {
				this.$nextTick(() => {
					this.dynamicValidateForm.bookno = value.replace(/\D/g,'').replace(/....(?!$)/g,'$& ');
				})
			}
		},
		['dynamicValidateForm.cardnonew'](type) {
			if (type != undefined) {
				this.$nextTick(() => {
					this.dynamicValidateForm.cardnonew = type.replace(/\D/g,'').replace(/....(?!$)/g,'$& ');
				})
			}
		}
	},
  methods: {
    ...mapActions("global", ["onExtendClick", "isExpand"]),
    ...mapActions("selectData", ["org_combox", "org_comboxchild","dic_combox",]),
		
    //改变分公司 change
    onChangeCompany(val, form) {
      this[form].schoolorgname = "";
      this[form].companyorgid = val;
      this.org_comboxchild(val);
    },
    onChangeSchool(val, form) {
      this[form].schoolorgid = val;
    },
    // 选择变更人
    selectBankChange() {
      this.showUserModal = true;
    },
		enterSelect(e) {
			if(e.keyCode === 13) {
				this.getDataList();
			}
		},
		visiableType(e) {
			if(!e) {
				this.$refs.selectref.blur()
			}
		},
		handleQuery() {
			this.selectSearchForm = {
				realname: null
			},
			this.onSelectData(this.selectTableUrl, null, null)
		},
    // 选择变更人确定
    comfirmUser() {
      selectCheck(this.multipleSelection, "确认专业", false, () => {
        this.dynamicValidateForm.changeuserid = this.multipleSelection[0].id;
        this.dynamicValidateForm.changeusername = this.multipleSelection[0].realname;
        this.showUserModal = false;
				this.multipleSelection = '';
				this.handleQuery();
      });
    },
		reset() {
			this.searchForm = {
				id: null,
				accountname: null,
				approvestate:null,
				schoolorgname:null,
				cardno: null
			}
		},
		//重置
		resetQuery() {
			this.reset();
			this.getDataList();
		},
    // 选择变更人搜索
    changeSeach() {},
    //关闭导出框
    onCloseExport(bool) {
      this.transferDialog = false;
    },
    //搜索 click
    seach() {
      this.pageinfo.pageindex = 1;
      this.getDataList();
    },
    //列表查询 api
    getDataList() {
      myRequest({
        url: account_listbank,
        data: Object.assign(this.searchForm, this.pageinfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.tableRes = res.data.data;
        }
      });
    },
    //切换当前页
    handleCurrentChange(val) {
      this.pageinfo.pageindex = val;
      this.getDataList();
    },
    //切换选项表格页
    handleSelectChange(val, data) {
      this.selectPageInfo.pageindex = val;
      this.onSelectData(this.selectTableUrl, null, data);
			this.onCloseSelect();
    },
    //触发所有btn方法
    onClickBtn(methodsName) {
      this.$options.methods[methodsName].call(this); //btnAdd ... （防止修改this指向）
    },
    // 查看详情 click
    btnShowDetail(row) {
      this.dynamicValidateForm = JSON.parse(JSON.stringify(row));
      this.showDetailModal = true;
    },
    //添加click
    btnAdd() {
			this.dialogTitle = "添加";
      this.dynamicValidateForm = {
        companyorgid: this.$store.state.login.userinfo.companyorgid,
        schoolorgid: this.$store.state.login.userinfo.schoolorgid,
      };
      this.$set(
        this.dynamicValidateForm,
        "companyorgname",
        this.$store.state.login.userinfo.companyorgname
      );
      this.$set(
        this.dynamicValidateForm,
        "schoolorgname",
        this.$store.state.login.userinfo.schoolorgname
      );
      this.org_comboxchild(this.dynamicValidateForm.companyorgid);
      this.showAddModal = true;
    },
    //修改click
    btnEdit() {
			this.dialogTitle = "修改";
      selectCheck(this.multipleSelection, "修改", false, () => {
        this.editRoutePage(this.multipleSelection[0].id);
      });
    },
    //刷新 click
    btnReload() {
      this.getDataList();
    },
    //修改路由页 api
    editRoutePage(id) {
      myRequest({
        url: account_inputbank,
        data: {
          id: id,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          this.showAddModal = true;
          this.dynamicValidateForm = res.data.data.taccount;
          this.org_comboxchild(this.dynamicValidateForm.companyorgid);
          delete this.dynamicValidateForm.inserttime; //inserttime 该字段不用传
          delete this.dynamicValidateForm.isoktime; //isoktime 该字段不用传
					delete this.dynamicValidateForm.ceoapprovetime; //kuaijiapprovetime该字段不用传
					delete this.dynamicValidateForm.kuaijiapprovetime; //kuaijiapprovetime该字段不用传
        }
      });
    },
    //提交-（添加，修改） api
    submitAddOrEditForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          myRequest(
            {
              url: account_savebank,
              data: this.dynamicValidateForm,
            },
            {
              isRefTableList: true,
              that: this,

              modal: "showAddModal",
            }
          );
        }
      });
    },
    // 银行卡变更 click
    btnCardchange() {
      selectCheck(this.multipleSelection, "银行卡变更", false, () => {
        this.cardchangeRoutePage(this.multipleSelection[0].id);
      });
    },
    // 银行卡变更 api
    cardchangeRoutePage(id) {
      myRequest(
        {
          url: bankaccountchange_input,
          data: {
            accountid: id,
          },
        },
        {
          isRefTableList: true,
          that: this,
        }
      ).then((res) => {
        if (res.data.code === "200") {
          this.showBankChangeModal = true;
          this.dynamicValidateForm = res.data.data.tbankaccountchange;
          delete this.dynamicValidateForm.inserttime; //inserttime 该字段不用传
          delete this.dynamicValidateForm.isoktime; //isoktime 该字段不用传
        }
      });
    },
    // 银行卡号更改 api
    submitBankChangeForm(dynamicValidateForm) {
      this.$refs[dynamicValidateForm].validate((valid) => {
        if (valid) {
          myRequest(
            {
              url: bankaccountchange_save,
              data: this.dynamicValidateForm,
            },
            {
              isRefTableList: true,
              that: this,

              modal: "showBankChangeModal",
            }
          );
        } else {
          this.$message({
            type: "warning",
            message: "红星必填",
          });
        }
      });
    },
    // 变更记录 click
    btnChangerecord() {
      selectCheck(this.multipleSelection, "银行卡变更", false, () => {
        this.watchRecord(this.multipleSelection[0].id);
      });
    },
    // 查看变更记录 api
    watchRecord(id) {
      myRequest({
        url: bankaccountchange_list,
        data: {
          accountid: this.multipleSelection[0].id,
          pageindex: this.pageinfo.pageindex,
          pagesize: this.pageinfo.pagesize,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          this.showRecordModal = true;
          this.recordTable = res.data.data;
        }
      });
    },
    // 查看变更记录点击页数 click
    recordHandleCurrentChange(val) {
      this.pageinfo.pageindex = val;
      this.watchRecord();
    },
    //提请审批 click
    btnRequestApprove() {
      selectCheck(this.multipleSelection, "提请审批", true, () => {
        confirmCallBack({
          title: "提示",
          content: "选中的条目将提请审批！",
          success: () => {
            this.reqApproval(this.multipleSelection.map((i) => i.id));
          },
          fail: () => {
            messageTip({
              message: "取消操作",
              type: "info",
            });
          },
        });
      });
    },
    //会计审批 click
    btnVeryfy1() {
      selectCheck(this.multipleSelection, "会计审批", false, () => {
        this.headApproval();
      });
    },
    //查看审批情况 click
    btnViewApprove() {
      selectCheck(this.multipleSelection, "查看审批", false, () => {
        this.approvelist();
      });
    },
    //导出 click
    btnExport() {
      this.transferDialog = true;
    },
    //提请审批 api
    reqApproval(ids) {
      myRequest(
        {
          method: "post",
          url: account_requestapprove,
          data: this.$qs.stringify(
            {
              ids: ids,
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          isRefTableList: true,
          that: this,
        }
      );
    },
    //审批检查 api
    headApproval() {
      myRequest(
        {
          method: "post",
          url: account_approvecheck,
          data: this.$qs.stringify(
            {
              ids: this.multipleSelection.map((i) => i.id),
              leadertype: "05",
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          that: this,
          showModal: "showApprovalModal",
        }
      );
    },
    //审批保存  api
    onApprovalClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.approvesave();
        }
      });
    },
    //查看审批 api
    approvelist() {
      myRequest({
        url: approve_list,
        data: {
          objectname: "T_ACCOUNT",
          objectid: this.multipleSelection[0].id,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          this.showTable = res.data.data;
          this.showModal = true;
        }
      });
    },
    //审批保存  api
    approvesave() {
      myRequest(
        {
          method: "post",
          url: account_approvesave,
          data: this.$qs.stringify(
            {
              ids: this.multipleSelection.map((i) => i.id),
              leadertype: "05",
              passflag: this.dynamicValidateForm.passflag,
              approvedesc: this.dynamicValidateForm.approvedesc,
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          modal: "showApprovalModal",
          isRefTableList: true,
          that: this,
        }
      );
    },
    //选项表格 api（专业）
    onSelectData(url, modal, data) {
      this.selectTableUrl = url;
      myRequest({
        url: this.selectTableUrl,
        data: Object.assign(data || {}, this.selectPageInfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
          this.selectTable = res.data.data;
					this.key = Math.random();
          this[modal] = true;
        }
      });
    },
    //选项表格 - 搜索 click
    onSelectSearchClick(url,modal,data){
      this.selectPageInfo.pageindex = 1
      this.onSelectData(url,modal,data)
    },
    //关闭选项框 click
    onCloseSelect() {
      this.selectPageInfo.pageindex = 1;
    },
    //选中表格数据改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>

<style  lang="scss">
</style>